import React from 'react';
import { useTranslation } from 'react-i18next';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import { CalendarFiltersPanel } from './CalendarFiltersPanel';
import { getSelectedFilterCount } from '../calendarFilters.helpers';
import './CalendarFilters.scss';

export function CalendarFilters({ filters, onChange, pmas, members }) {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const containerRef = React.useRef(null);
  const selectedFilterCount = getSelectedFilterCount(filters);

  React.useEffect(() => {
    if (!open) return undefined;
    const closeOnOutsideClick = (event) => {
      if (!containerRef.current?.contains(event.target)) setOpen(false);
    };
    const closeOnEscape = (event) => {
      if (event.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', closeOnOutsideClick);
    document.addEventListener('keydown', closeOnEscape);
    return () => {
      document.removeEventListener('mousedown', closeOnOutsideClick);
      document.removeEventListener('keydown', closeOnEscape);
    };
  }, [open]);

  return (
    <div className="calendar-filters" ref={containerRef}>
      <button
        type="button"
        className={`calendar-filters__trigger${selectedFilterCount ? ' is-active' : ''}`}
        onClick={() => setOpen((value) => !value)}
        aria-expanded={open}
        aria-haspopup="dialog"
      >
        <TuneOutlinedIcon fontSize="small" />
        {t('calendar-filters', { defaultValue: 'Filters' })}
        <KeyboardArrowDownIcon fontSize="small" />
        {selectedFilterCount > 0 && <span className="calendar-filters__count">{selectedFilterCount}</span>}
      </button>
      {open && (
        <CalendarFiltersPanel
          filters={filters}
          pmas={pmas}
          members={members}
          onClose={() => setOpen(false)}
          onApply={(nextFilters) => {
            onChange(nextFilters);
            setOpen(false);
          }}
        />
      )}
    </div>
  );
}
